/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Status of a transaction within the ACH lifecycle.
 */
export const ACHTransactionStatus = {
  Unknown: "",
  Initiated: "initiated",
  Originated: "originated",
  Corrected: "corrected",
  Returned: "returned",
  Completed: "completed",
  Canceled: "canceled",
} as const;
/**
 * Status of a transaction within the ACH lifecycle.
 */
export type ACHTransactionStatus = ClosedEnum<typeof ACHTransactionStatus>;

/** @internal */
export const ACHTransactionStatus$inboundSchema: z.ZodNativeEnum<
  typeof ACHTransactionStatus
> = z.nativeEnum(ACHTransactionStatus);
/** @internal */
export const ACHTransactionStatus$outboundSchema: z.ZodNativeEnum<
  typeof ACHTransactionStatus
> = ACHTransactionStatus$inboundSchema;
